import React, { useContext, useEffect, useState } from "react";
import userDefaultImage from "../../images/default-profile.png";
import errorIcon from "../../images/errorRedIcon.png";
import successIcon from "../../images/successGreenIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { AppContext } from "../../contexts/AppContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ProjectSupporter({ users, project }) {
  const { listOverview, setListOverview } = useContext(AppContext);
  const [selectedProjectSupporter, setSelectedProjectSupporter] = useState("");
  const [selectedProjectSupporterImage, setSelectedProjectSupporterImage] =
    useState(userDefaultImage);
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);

  useEffect(() => {
    if (project.project_supporter) {
      setSelectedProjectSupporter(project.project_supporter);
      const selectedUser = users.find(
        (user) => user.username === project.project_supporter
      );
      if (selectedUser) {
        if (selectedUser.profilePicture) {
          setSelectedProjectSupporterImage(selectedUser.profilePicture);
        } else {
          setSelectedProjectSupporterImage(userDefaultImage);
        }
      }
    }
  }, [project.project_supporter, users]);

  const updateProjectSupporter = (value) => {
    setReturnError(false);
    setLoading(true);
    setSelectedProjectSupporter(value);
    const selectedUser = users.find((user) => user.username === value);
    if (selectedUser) {
      if (selectedUser.profilePicture) {
        setSelectedProjectSupporterImage(selectedUser.profilePicture);
      } else {
        setSelectedProjectSupporterImage(userDefaultImage);
      }
    } else {
      setSelectedProjectSupporterImage(userDefaultImage);
    }
    const listSupporter = value;
    const listID = project.id;
    const selectedProject = listOverview.filter(
      (proj) => proj.id === listID
    )[0];
    const modifiedProject = {
      ...selectedProject,
      project_supporter: listSupporter,
    };
    const projectData = {
      listSupporter,
      listID,
    };
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(`${API_URL}update-list-supporter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(projectData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setListOverview(
            listOverview.map((project) =>
              project.id === modifiedProject.id ? modifiedProject : project
            )
          );
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        Swal.fire({
          icon: "error",
          title: "Database connection error!",
          text: "Please logout and try again.",
          confirmButtonText: "OK",
        });
        console.log(err);
      });
  };

  return (
    <>
      <div className="project-supporter" title="Project Supporter">
        {selectedProjectSupporter === "" ||
        selectedProjectSupporter === "Select" ? (
          <div style={{ width: "24px" }}></div>
        ) : (
          <img
            src={selectedProjectSupporterImage}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = userDefaultImage;
            }}
            width={24}
            height={24}
            className="rounded-circle"
            alt=""
          />
        )}
      </div>
      <select
        id="pjSpporter"
        className="pjSpporter-select"
        title="Project Supporter"
        value={selectedProjectSupporter}
        onChange={(e) => {
          setReturnError(false);
          updateProjectSupporter(e.target.value);
        }}
      >
        <option value="">Select</option>
        {users?.map((user) => (
          <option key={user.username} value={user.username}>
            {user.username}
          </option>
        ))}
      </select>
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", left: "182px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}

      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", left: "182px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "12px", left: "182px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
